import { Route, Routes } from "react-router-dom";
import ManageToDoItems from "./ManageToDoItems";

export default function ManageToDoItemsRouter() {
  return (
    <Routes>
      <Route path="/" element={<ManageToDoItems />} />
    </Routes>
  );
}
